import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e72a17c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "image image--1",
  "data-reveal-on-scroll": "true"
}
const _hoisted_2 = { class: "image__container" }
const _hoisted_3 = { class: "image__image_container" }
const _hoisted_4 = ["width", "height", "src", "alt"]
const _hoisted_5 = { class: "image__text_container" }
const _hoisted_6 = {
  key: 0,
  class: "image__caption"
}
const _hoisted_7 = {
  key: 1,
  class: "image__text image__text--1"
}
const _hoisted_8 = {
  key: 1,
  class: "image image--2",
  "data-reveal-on-scroll": "true",
  "data-reveal-on-scroll-delay": "0.2"
}
const _hoisted_9 = { class: "image__container" }
const _hoisted_10 = { class: "image__image_container" }
const _hoisted_11 = ["width", "height", "src", "alt"]
const _hoisted_12 = { class: "image__text_container" }
const _hoisted_13 = {
  key: 0,
  class: "image__caption"
}
const _hoisted_14 = {
  key: 1,
  class: "image__text image__text--2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_section = _resolveComponent("page-section")!
  const _directive_sanitize = _resolveDirective("sanitize")!

  return (_openBlock(), _createBlock(_component_page_section, {
    class: _normalizeClass(["images", [`images--template-${_ctx.template}`]]),
    backgroundColor: _ctx.backgroundColor || null
  }, {
    default: _withCtx(() => [
      (_ctx.image1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "image__image",
                  style: _normalizeStyle(`background-image: url(${_ctx.image1.src});`)
                }, null, 4),
                _createElementVNode("img", {
                  class: "image__placeholder",
                  width: _ctx.image1.width,
                  height: _ctx.image1.height,
                  src: _ctx.image1.src,
                  alt: _ctx.image1.alt
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.image1.caption)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.image1.caption), 1))
                  : _createCommentVNode("", true),
                (_ctx.image1.text)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, null, 512)), [
                      [_directive_sanitize, _ctx.image1.text]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.templateAllowsForTwoImages && _ctx.image2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "image__image",
                  style: _normalizeStyle(`background-image: url(${_ctx.image2.src});`)
                }, null, 4),
                _createElementVNode("img", {
                  class: "image__placeholder",
                  width: _ctx.image2.width,
                  height: _ctx.image2.height,
                  src: _ctx.image2.src,
                  alt: _ctx.image2.alt
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.image2.caption)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.image2.caption), 1))
                  : _createCommentVNode("", true),
                (_ctx.image2.text)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, null, 512)), [
                      [_directive_sanitize, _ctx.image2.text]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "backgroundColor"]))
}